import React, {useEffect, useState, useCallback,useMemo} from 'react';
import MomentTimezone from 'moment-timezone';
import './Timezone.scss';

const TimeZone = () => {    
    const [initialTime,setInitialTime] = useState<any>([]);
    const currentIndex = 0;
    const [currentTimzone,setCurrentTimzone] =  useState(currentIndex);
    const [timezone,setTimezone] = useState<any>([]);
    const initialTimezone = useMemo(() => {
     return [
            {
                name: 'CST',
                time:'America/Chicago'
            },
            {
                name: 'EST',
                time:'America/New_York'
            },
            {
                name: 'PST',
                time:'America/Los_Angeles'
            }];
    },[]);

    useEffect(() => {
        const timezoneSet = setInterval(()=> {
            let timezoneList = initialTimezone.map((item:any) => {
                let momentTime = MomentTimezone.utc(new Date());
                let location = momentTime.tz(item.time);
                let timeDatset = {place:'',time:'',day:'',date:''};
                timeDatset.place = item.name;
                timeDatset.time = location.format('HH:mm');
                timeDatset.day = location.format('dddd');
                timeDatset.date = location.format('MMM DD');
                return timeDatset;
            });
            setInitialTime(timezoneList);
        },1000);

        return () => clearInterval(timezoneSet);
    },[initialTimezone]);

   useEffect(()=> {
       if(initialTime.length) {
        setTimezone(initialTime.slice(currentTimzone, (currentTimzone+1)));
       }
   },[initialTime,currentTimzone]);

   const leftNav = useCallback(() => {
       let current = currentTimzone - 1;
       if(currentTimzone === 0) {
        current = initialTime.length - 1;
       }
       setTimezone(initialTime.slice(current,(current+1)));
       setCurrentTimzone(current);
   },[initialTime,currentTimzone])

   const rightNav = useCallback(() => {
        let current = currentTimzone + 1;
        if(currentTimzone === (initialTime.length - 1)) {
            current = 0;
        }
        
        setTimezone(initialTime.slice(current,(current+1)));
        setCurrentTimzone(current);
    },[initialTime,currentTimzone]);

    return <div className='clearfix'>
          <div className='timezone'>
                    {
                        timezone.length?
                        timezone.map((item:any,index:number)=> {
                            return <div className='timezoneBlock' key={index}>
                                    <div className='timezoneHeader'>
                                        <div className='clearfix'>
                                            <div className='float-start'>
                                                <span className='fa fa-map-marker mapMarker'></span>{item.place}
                                            </div>
                                            <div className='float-end arrowNav'>
                                                <div className='me-2' onClick={leftNav}>
                                                    <span className='fa fa-angle-left'></span>
                                                </div>
                                                <div onClick={rightNav}>
                                                    <span className='fa fa-angle-right'></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='timezoneBody'>
                                       <div className='clearfix'>
                                        <div className='float-left timezoneLeft'>
                                            <div className='time'>{item.time}</div>
                                        </div>
                                        <div className='float-left'>
                                            <div className='day'>{item.day}</div>
                                            <div className='date'>{item.date}</div>
                                        </div>
                                       </div>
                                    </div>
                                </div>
                        }) : null
                    }
            </div>      
    </div>
}

export default TimeZone